import { Button } from '../../components/Button';

interface EditTripActionsProps {
  hasUnpublishedChanges: boolean;
  isPublishing: boolean;
  onPublish: () => void;
  onViewTrip: () => void;
}

/**
 * Presentational component for edit trip action buttons.
 * Shows publish and view trip buttons.
 */
export const EditTripActions = ({
  hasUnpublishedChanges,
  isPublishing,
  onPublish,
  onViewTrip,
}: EditTripActionsProps) => {
  return (
    <div className="relative mt-8 mb-8 max-w-7xl mx-auto px-4 md:px-8">
      <div className="flex justify-center gap-3">
        <Button
          variant="primary"
          disabled={!hasUnpublishedChanges || isPublishing}
          loading={isPublishing}
          title={
            hasUnpublishedChanges
              ? isPublishing
                ? 'Publishing...'
                : 'Publish your changes'
              : 'Already up-to-date'
          }
          onClick={onPublish}
        >
          {isPublishing ? 'Publishing...' : 'Publish Changes'}
        </Button>
        <Button variant="secondary" title="View your trip" onClick={onViewTrip}>
          View Trip
        </Button>
      </div>
    </div>
  );
};
